module.exports = __webpack_public_path__ + "img/logo-so-khcn.40ff5e68.png";